import React from 'react';
import SkeletonImage from './common/SkeletonImage';

// Mapping des codes ISO vers les URLs des drapeaux
const getFlagUrl = (countryCode) => {
  if (!countryCode || typeof countryCode !== 'string' || countryCode.length !== 2) {
    return null;
  }
  
  const code = countryCode.toLowerCase();
  // Utilisation d'une source fiable pour les drapeaux SVG
  return `https://flagcdn.com/w40/${code}.png`;
};

const CountryFlag = ({ code, className = '', style = {}, size = 24 }) => {
  const flagUrl = getFlagUrl(code);
  const countryCode = code ? code.toUpperCase() : '';
  
  if (!flagUrl) {
    return (
      <span
        className={className}
        style={style}
        role="img"
        aria-label="Drapeau inconnu"
      >
        🌐
      </span>
    );
  }

  return (
    <SkeletonImage
      src={flagUrl}
      alt={`Drapeau ${countryCode}`}
      className={className}
      style={{
        width: `${size}px`,
        height: `${size * 2 / 3}px`,
        verticalAlign: 'middle',
        ...style
      }}
      imgClassName="w-full h-full object-contain"
      icon={false}
    />
  );
};

export default CountryFlag;